export const GUARD_MAIN = 'main';
export const GUARD_RELATIVE = 'relative';
export const GUARD_NONE = 'none';